document.addEventListener("DOMContentLoaded", ()=>{
    const scrollToTop = document.getElementById("scroll-to-top")
    if(scrollToTop) {

        const toggleScrollToTop = function() {
            if(window.scrollY > window.innerHeight * 0.63) {
                scrollToTop.classList.remove("inactive")
            }else{
                scrollToTop.classList.add("inactive")
            }
        }

        window.addEventListener("scroll", toggleScrollToTop)
        window.addEventListener("resize", toggleScrollToTop)
        toggleScrollToTop()
    }
})